import axios from "axios";
import { BACKEND_URL } from "./constants";

export const getApiConfig = () => {
  try {
    const token = localStorage.getItem('properties_api_token') || '';
    const endpoint = localStorage.getItem('properties_api_endpoint') || '';
    return { token, endpoint };
  } catch (error) {
    console.error('Error getting API config:', error);
    return { token: '', endpoint: '' };
  }
};

export const createApiRequest = () => {
  const { token, endpoint } = getApiConfig();
  const headers = {};

  if (token) {
    headers['X-Properties-API-Token'] = token;
  }
  if (endpoint) {
    headers['X-Properties-API-Endpoint'] = endpoint;
  }

  return axios.create({
    baseURL: BACKEND_URL,
    headers
  });
};
